import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum, SUPPORT_PHONE_NUMBER } from 'myParkdUtils/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faCommentDollar, faCommentAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import AppWrapper from 'components/board/AppWrapper';
import { ReduxState } from 'types';
import MainHeader from 'components/board/MainHeader';
import MainContent from 'components/board/MainContent';


export const URL_SUPPORT_GENERAL = 'https://concar.atlassian.net/servicedesk/customer/portal/2/group/14/create/39';
export const URL_SUPPORT_FINES = 'https://concar.atlassian.net/servicedesk/customer/portal/2/group/12/create/35';

const SupportScreen = (props: Props) => {
    return (
        <AppWrapper>
            <main id="page-support" className="col-main">

                <MainHeader>
                    <div className="header-v-align">
                        <h2 className="main-header-title">
                            <FormattedMessage id="GLOBAL_SUPPORT" />
                        </h2>
                    </div>
                </MainHeader>

                <MainContent>
                    <div className="board-content radius-rectangle">
                        <ul className="support-links">
                            <li>
                                <a className='fake-link' href={URL_SUPPORT_GENERAL} target={'_blank'} rel={'noreferrer'}>
                                    <FontAwesomeIcon icon={faCommentAlt} className="fa-icon" />
                                    <FormattedMessage id="CONTACT_SUPPORT" />
                                </a>
                            </li>
                            <li>
                                <a className='fake-link' href={URL_SUPPORT_FINES} target={'_blank'} rel={'noreferrer'}>
                                    <FontAwesomeIcon icon={faCommentDollar} className="fa-icon" />
                                    <FormattedMessage id="SUPPORT_LINK_I_RECEIVED_A_PARKING_FINE" />
                                </a>
                            </li>
                            <li>
                                <span className="fake-link" onClick={() => props.openModal(ModalEnum.SEND_FEEDBACK_TO_SUPPORT)}>
                                    <FontAwesomeIcon icon={faCommentDots} className="fa-icon" />
                                    <FormattedMessage id="FEEDBACK_BOX_SEND_FEEDBACK" />
                                </span>
                            </li>
                            <li>
                                <span className="fake-link" onClick={() => { }}>
                                    <FontAwesomeIcon icon={faPhone} className="fa-icon" />
                                    {props.companyCountryCode === 'BE'
                                        ? SUPPORT_PHONE_NUMBER.BE
                                        : SUPPORT_PHONE_NUMBER.NL
                                    }
                                </span>
                            </li>
                        </ul>
                    </div>
                </MainContent>

            </main>
        </AppWrapper>
    );
};


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

function mapStateToProps(state: ReduxState) {
    return {
        companyCountryCode: state.companyDetails?.companyDetails?.address?.countryCode,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        openModal: modalWindowActions.updateModalWindow,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportScreen);